
import { getActions } from '../sagas';
import { sagas } from '../../multiscene';

/**
 * Command `mapmultiscene.showPosition`
 *
 * Mode `pano` and `pano_points`:
 * Position of camera is defined by photo. Required parameters are trjName, photoName
 *
 * Mode `points`:
 * Position of camera is defined by coordinates x,y,z. Required parameters are trjName, x, y, z
 *
 * Without `mode` parameter, actual mode is used.
 *
 * Parameter `yaw` and `pitch` for camera direction are optional. If these parameters are missed
 * actual direction is used.
 *
 *
 * @typedef {Object} MultSceneForApp~MapMultiScene~Commands~ShowPosition
 * @property {string} command - name of command, has value `multiscene.showPosition`
 * @property {String} trjName - name of trajectory
 * @property {String} photoName - name of photo on trajectory
 * @property {Number} x - x coordinate of camera's position
 * @property {Number} y - y coordinate of camera's position
 * @property {Number} z - z coordinate of camera's position
 * @property {Number} yaw - camera direction (azimuth)
 * @property {Number} pitch - camera direction (up and down)
 * @property {String} mode - type of mode (pano, pano_points, points)
 */
function showPosition(params, dispatch) {
    if (params.mode) {
        sagas.getActions(dispatch).selectMode(params.mode);
    }
    getActions(dispatch).setMmsPoint({
        trj_name: params.trjName,
        photo_name: params.photoName,
        x: params.x,
        y: params.y,
        z: params.z,
        yaw: params.yaw,
        pitch: params.pitch,
        mode: params.mode
    });
}

export default {
    name: 'mapmultiscene.showPosition',
    execute: showPosition
}
